import {
  useDisclosure,
  MenuList,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  Portal,
  MenuDivider,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '../../Icons';
import {
  GeneralSamplesMenuActions,
  SampleNextActionProps,
  useGeneralSampleModals,
} from '../SampleNextAction';
import { AcceptModal } from '@texas/components/article/productApproval/changeStateModals/AcceptModal';
import { productApprovalEvents } from '../../productApproval/events';
import { usePortalRefValue } from '@texas/hooks/usePortalRef';

export function SentToBrandHandlePa(props: SampleNextActionProps) {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { ref } = usePortalRefValue();

  const {
    setLostOnOpen,
    updateOwnerOnOpen,
    rejectOnOpen,
    stopFollowOnOpen,
    modals,
  } = useGeneralSampleModals();

  if (!props.sampleId) {
    return null;
  }

  return (
    <>
      <Menu isLazy={true}>
        <MenuButton
          as={IconButton}
          size="sm"
          variant="ghost"
          aria-label={t('sample.menu')}
          icon={<Icons.DotsHorizontal boxSize={defaultIconSize} />}
        />
        <Portal containerRef={ref}>
          <MenuList zIndex={10}>
            <MenuItem
              onClick={onOpen}
              icon={<Icons.CheckmarkDecagram boxSize={defaultIconSize} />}
            >
              {t('productApproval.acceptPa')}
            </MenuItem>
            <MenuDivider />
            <GeneralSamplesMenuActions
              pas={[props.pa!]}
              sampleIds={[props.sampleId]}
              rejectOnOpen={rejectOnOpen}
              setLostOnOpen={setLostOnOpen}
              updateOwnerOnOpen={updateOwnerOnOpen}
              stopFollowOnOpen={
                props.hideStopFollowing ? null : stopFollowOnOpen
              }
            />
          </MenuList>
        </Portal>
      </Menu>

      {modals}
      <AcceptModal
        productApprovalId={props.pa!.id}
        branchId={props.branchId}
        variantId={props.variantId}
        isOpen={isOpen}
        onClose={onClose}
        onAccept={() => {
          productApprovalEvents.productApprovalAccepted.dispatch();
        }}
      />
    </>
  );
}
